import React, { useState, useEffect } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';

const FormularioNoticia = ({ noticiaSeleccionada, onGuardar, onCancelar }) => {
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    noticia: '',
    motivation: '',
    date: '',
    content: '',
    author: '',
    image: null,
  });

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  useEffect(() => {
    if (noticiaSeleccionada) {
      setFormData({
        title: noticiaSeleccionada.title,
        subtitle: noticiaSeleccionada.subtitle,
        noticia: noticiaSeleccionada.noticia,
        motivation: noticiaSeleccionada.motivation,
        date: noticiaSeleccionada.date,
        content: noticiaSeleccionada.content,
        author: noticiaSeleccionada.author,
        image: noticiaSeleccionada.image,
      });
    }
  }, [noticiaSeleccionada]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowSuccessAlert(false); // Reset alerts
    setShowErrorAlert(false);
    
    try {
      await onGuardar(formData);
      setShowSuccessAlert(true);
    } catch (error) {
      setShowErrorAlert(true);
    }
  };
  return (
    <>
     {showSuccessAlert && (
        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
          Noticia publicada.
        </Alert>
      )}
      {showErrorAlert && (
        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
          Fallo al publicar.
        </Alert>
      )}
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="title">
        <Form.Label>Título</Form.Label>
        <Form.Control
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
        />
      </Form.Group>
      <Form.Group controlId="subtitle">
        <Form.Label>Subtítulo</Form.Label>
        <Form.Control
          type="text"
          name="subtitle"
          value={formData.subtitle}
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group controlId="noticia">
        <Form.Label>Noticia</Form.Label>
        <Form.Control
          as="textarea"
          name="noticia"
          value={formData.noticia}
          onChange={handleChange}
          rows={3}
          required
        />
      </Form.Group>
      <Form.Group controlId="motivation">
        <Form.Label>Motivación</Form.Label>
        <Form.Control
          type="text"
          name="motivation"
          value={formData.motivation}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group controlId="content">
        <Form.Label>Contenido</Form.Label>
        <Form.Control
          as="textarea"
          name="content"
          value={formData.content}
          onChange={handleChange}
          rows={5}
          required
        />
      </Form.Group>
      <Form.Group controlId="author">
        <Form.Label>Autor</Form.Label>
        <Form.Control
          type="text"
          name="author"
          value={formData.author}
          onChange={handleChange}
          required
        />
      </Form.Group>
      <Form.Group controlId="image">
        <Form.Label>Imagen</Form.Label>
        <Form.Control
          type="file"
          name="image"
          onChange={handleChange}
        />
      </Form.Group>
      <div className="mt-3">
        <Button variant="primary" type="submit">
          Guardar
        </Button>{' '}
        <Button variant="secondary" onClick={onCancelar}>
          Cancelar
        </Button>
      </div>
    </Form>
    </>
  );
};

export default FormularioNoticia;
